export default "__VITE_ASSET__048aca25__"